import { createSlice, PayloadAction } from '@reduxjs/toolkit';


const initialState:any = {};

const recoverServersSlice = createSlice({
  name: 'recoverServers',
  initialState,
  reducers: {
    setRecoverServers(state,action:PayloadAction<any>){
      state.recoverServers = action.payload;
    }
  },

});

// Reducer
export default recoverServersSlice.reducer;

// Actions
export const {setRecoverServers} = recoverServersSlice.actions;

